module.exports = __webpack_public_path__ + "static/media/mrinal.98e2e747.png";